// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1ibxe","footer":"Form_footer__2NZTj"};